<template>
  <div class="py-3">
    <h4>Call Statistics</h4>
    <div
      class="mx-2"
      v-if="['1', '9'].includes(currentUser.role_id) || isBdrUser()"
    >
      <div class="col-md-12 px-0">
        <div
          class="container-fluid w-100 mb-5 p-3 border bg-white rounded stats-wrapper"
        >
          <div class="d-flex flex-wrap">
            <div class="w-25 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >Date</span
                >
              </div>
              <date-picker
                id="startDatePicker"
                class="form-control"
                v-model="filterMonth"
                :config="datePickerConfig"
                placeholder="Start Date"
              ></date-picker>
            </div>

            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper" v-if="!isBdrUser()">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >BDR</span
                >
              </div>
              <treeselect
                v-model="bdr_user_id"
                :options="bdr_users"
                :multiple="false"
                :clearable="false"
                :normalizer="normalizeOptions"
                class="form-control inline-table"
                @change="changeBDR"
              >
              </treeselect>
            </div>

            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper" v-if="!isBdrUser()">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >Booker Type</span
                >
              </div>
              <select class="form-control" v-model="booker_type">
                <option value="all">All Types</option>
                <option value="human">Human</option>
                <option value="ai_agent">Agent AI</option>
              </select>
            </div>

            <div class="w-25 ml-auto">
              <div class="col-md-12 d-flex justify-content-end">
                <button class="btn btn-success" :disabled="loading" @click="changeBDR()">
                  <i class="icon-calendar-check-o mr-2"></i>
                  <small>
                    {{ $t("lang.button.filter") }}
                  </small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row my-1 px-2 mx-0">
      <div class="px-3 pb-2">
        <Tabs
          :tabs="callStatisticsTabs"
          :tabSelected="tabSelected"
          @change="changeTab($event)"
        />
      </div>
    </div>

    <LoadingSpinner v-if="loading" />

    <div class="row" v-else>
      <div
        class="col-sm-12 mt-5"
        v-if="tabSelected === 1 || tabSelected === 2"
      >
        <div class="table-responsive">
          <div v-for="(parent, key) in parents" :key="parent + key">
            <div class="pb-4 max-content table-sticky-1col">
              <h3 class="ml-3">{{ parent.parent_name }}</h3>
              <div class="table-sticky-1col">
                <StatsTable
                  :statsClient="statsClient[parent.parent_name]"
                  :statsType="getStatsTypeByParent(parent.parent_name)"
                  :statsDate="statsDate"
                  :showTotal="
                    parent.parent_name == 'Percentages' ? false : true
                  "
                />
              </div>
            </div>
          </div>
        </div>

        <template v-if="tabSelected === 2 && parentsQualifications.length">
          <h5 class="ml-3 mt-5 mb-2">Qualification details</h5>
          <div class="table-responsive">
            <div
              v-for="(parent, key) in parentsQualifications"
              :key="'qual-' + key"
            >
              <div class="pb-4 max-content table-sticky-1col">
                <h3 class="ml-3">{{ parent.parent_name }}</h3>
                <div class="table-sticky-1col">
                  <StatsTable
                    :statsClient="
                      statsClientQualifications[parent.parent_name]
                    "
                    :statsType="
                      getStatsTypeByParentQualifications(parent.parent_name)
                    "
                    :statsDate="statsDateQualifications"
                    :showTotal="
                      parent.parent_name == 'Percentages' ? false : true
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { opportunitiesService, usersService } from "@/_services";
import StatsTable from "@/components/Usages/StatsTable.vue";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  props: {
    type: String,
    targetId: {
      type: String,
      default: "0",
    },
  },
  components: {
    StatsTable,
    LoadingSpinner,
    Tabs,
    Treeselect,
  },
  data() {
    return {
      tabSelected: 1,
      callStatisticsTabs: [
        { id: 1, name: "Conversations" },
        { id: 2, name: "Qualifications" },
      ],
      loading: true,
      statsClient: {},
      statsDate: [],
      parents: [],
      statsType: [
        // {
        //   id: "gmail_gmail",
        //   label: "gmail > gmail",
        //   format: "percentage",
        //   showQty: false,
        //   showTotal: false,
        //   parent: "sent",
        // },
      ],
      statsClientQualifications: {},
      statsDateQualifications: [],
      parentsQualifications: [],
      statsTypeQualifications: [],
      selectUserBdr: false,
      bdr_user_id: null,
      booker_type: "all",
      bdr_users: null,
      datePickerConfig: {
        format: "YYYY-MMM",
        // useCurrent: false,
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      filterMonth: moment().format("YYYY-MMM"),
      // range: {
      //   startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      //   endDate: moment().format("YYYY-MM-DD"),
      // },
    };
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
  },
  created() {
    this.getUserBdr();
    this.changeBDR();
  },
  methods: {
    changeTab(id) {
      if (this.tabSelected === id) return;
      this.tabSelected = id;
      this.changeBDR();
    },
    buildStatisticsSearchFilter(userBdr) {
      const base = {
        bdr_user_id: userBdr,
        month: this.filterMonth,
        type: this.type,
        target_id: this.targetId,
        booker_type: this.booker_type,
      };
      if (this.tabSelected === 1) {
        return {
          ...base,          
          statistics_view: "conversations",
        };
      }
      if (this.tabSelected === 2) {
        return {
          ...base,
          statistics_view: "qualifications",
        };
      }
      return base;
    },
    isBdrUser() {
      return (
        this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2
      );
    },
    mergeObjects(statsX, statsX2) {
      statsX2.forEach((item2) => {
        let item = statsX.find((item) => item.fdate == item2.fdate);
        if (item) {
          Object.assign(item, item2);
        } else {
          statsX.push(item2);
        }
      });
      return statsX;
    },
    changeBDR() {
      this.loading = true;
      this.statsClient = {};
      this.statsDate = [];
      this.parents = [];
      this.statsType = [];
      this.statsClientQualifications = {};
      this.statsDateQualifications = [];
      this.parentsQualifications = [];
      this.statsTypeQualifications = [];

      const userBdr = this.isBdrUser() ? this.currentUser.id : this.bdr_user_id;

      opportunitiesService
        .getBookersCallStatistics(this.buildStatisticsSearchFilter(userBdr))
        .then((res) => {
          const primary = res["callStatis"];
          if (primary != null && Array.isArray(primary) && primary.length) {
            const built = this.materializeCallStatisticsRows(primary);
            this.statsClient = built.statsClient;
            this.statsDate = built.statsDate;
            this.parents = built.parents;
            this.statsType = built.statsType;
          }

          if (this.tabSelected === 2) {
            const qualRows = res["callStatisQualifications"];
            if (
              qualRows != null &&
              Array.isArray(qualRows) &&
              qualRows.length
            ) {
              const builtQ = this.materializeCallStatisticsRows(qualRows);
              this.statsClientQualifications = builtQ.statsClient;
              this.statsDateQualifications = builtQ.statsDate;
              this.parentsQualifications = builtQ.parents;
              this.statsTypeQualifications = builtQ.statsType;
            }
          }

          this.loading = false;
        });
    },
    materializeCallStatisticsRows(rows) {
      const statsType = [];
      let statsX = this.formatData(
        rows,
        "total_call",
        "Volumens",
        "qty",
        statsType
      );

      const callStatisPer = [];
      rows.forEach((item) => {
        const total = rows
          .filter((el) => item.fdate == el.fdate)
          .reduce((sum, row) => sum + parseInt(row.total_call, 10), 0);

        const data = {
          fdate: item.fdate,
          total_call_per:
            total > 0
              ? ((Number(item.total_call) / total) * 100).toFixed(2)
              : "0",
          detail: item.detail,
          name: item.name,
        };
        callStatisPer.push(data);
      });

      const statsX1 = this.formatData(
        callStatisPer,
        "total_call_per",
        "Percentages",
        "rate",
        statsType
      );

      statsX = this.mergeObjects(statsX, statsX1);

      const statsClient = {};
      const statsDate = [];
      const parents = [];

      statsX.forEach((item) => {
        const client_id = item.client_id ? item.client_id : 0;
        const client_name = item.client_name ? item.client_name : "";
        const fdate = item.fdate;

        if (!statsDate.find((field) => field.date == fdate)) {
          statsDate.push({ date: fdate });
        }

        statsType.forEach((statType) => {
          const type = statType.id + "_" + statType.format;
          const parent = statType.parent;

          if (!parents.find((field) => field.parent_name == parent)) {
            parents.push({ parent_name: parent });
          }

          if (statsClient[parent] == undefined) {
            statsClient[parent] = {};
          }
          if (statsClient[parent][client_id] == undefined) {
            statsClient[parent][client_id] = {};
            statsClient[parent][client_id]["name"] = client_name;
          }
          if (statsClient[parent][client_id][fdate] == undefined) {
            statsClient[parent][client_id][fdate] = item;
          }

          if (item[type] !== undefined && item[type] !== null) {
            if (statsClient[parent][client_id][type] === undefined) {
              statsClient[parent][client_id][type] = 0;
              statsClient[parent][client_id][type + "_total"] = 0;
            }
            statsClient[parent][client_id][type] += parseFloat(item[type]);
            statsClient[parent][client_id][type + "_total"]++;
          }
        });
      });

      statsDate.sort((a, b) => a.date - b.date);

      statsType.forEach((statType) => {
        const type = statType.id + "_" + statType.format;
        const parent = statType.parent;

        if (["avg", "percentage", "rate"].includes(statType.format)) {
          statsClient[parent][0][type] =
            statsClient[parent][0][type] /
            statsClient[parent][0][type + "_total"];
        }
      });

      return { statsClient, statsDate, parents, statsType };
    },
    getUserBdr() {
      usersService
        .getBdrs()
        .then((res) => {
          this.bdr_users = res.result;
        })
        .catch((err) => consolelog(err));
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    formatData(x, field_value, parent, format_type, statsTypeBucket = null) {
      const statsTypeRef =
        statsTypeBucket !== null ? statsTypeBucket : this.statsType;
      let statsX = [];
      let total = 0;
      let total1 = 0;
      let total2 = 0;
      x.forEach((item) => {
        const fdate = item.fdate;
        if (!statsX.find((field) => field.fdate == fdate)) {
          statsX.push({ fdate: fdate });
        }
        let statWeek = statsX.find((field) => field.fdate == fdate);
        let label = item.name;
        let key = label + "_" + parent;

        let value = 0;
        if (Array.isArray(field_value)) {
          if (item[field_value[1]] > 0) {
            let val0 = parseInt(item[field_value[0]]);
            let val1 = parseInt(item[field_value[1]]);
            total1 += val0;
            total2 += val1;
            total = total1 / total2;
            value = val0 / val1;
            if (["percentage", "rate"].includes(format_type)) {
              value = value * 100;
            }
          }
        } else {
          value = item[field_value];
        }

        statWeek[key + "_" + format_type] = value;
        if (Array.isArray(field_value)) {
          statWeek["Total_" + parent + "_" + format_type] = total * 100;

          if (!statsTypeRef.find((field) => field.id == "Total_" + parent)) {
            statsTypeRef.push({
              id: "Total_" + parent,
              label: "Total",
              format: format_type,
              showQty: false,
              showTotal: true,
              parent: parent,
              className: "font-weight-bold",
            });
          }
        }

        if (!statsTypeRef.find((field) => field.id == key)) {
          statsTypeRef.push({
            id: key,
            label: label,
            format: format_type,
            showQty: false,
            showTotal: true,
            parent: parent,
          });
        }
      });
      return statsX;
    },

    getStatsTypeByParent(parent) {
      if (this.type == "timing") {
        let x = this.statsType.filter((e) => e.parent === parent);

        const entries = Object.entries(x);

        entries.sort(([keyA, valueA], [keyB, valueB]) => {
          let a = valueA.label == "Total" ? 9999 : parseInt(valueA.label);
          let b = valueB.label == "Total" ? 9999 : parseInt(valueB.label);
          return a - b;
        });

        return entries.map(([, value]) => value);
      }

      if (this.tabSelected === 2) {
        let x = this.statsType.filter((e) => e.parent === parent);
        const qualificationsOrder = [
          "New meeting",
          "Rescheduled meeting",
          "No meeting",
          "Total",
        ];
        const entries = Object.entries(x);
        entries.sort(([keyA, valueA], [keyB, valueB]) => {
          const indexA = qualificationsOrder.indexOf(valueA.label);
          const indexB = qualificationsOrder.indexOf(valueB.label);
          return (
            (indexA === -1 ? Infinity : indexA) -
            (indexB === -1 ? Infinity : indexB)
          );
        });
        return entries.map(([, value]) => value);
      }

      let x = this.statsType.filter((e) => e.parent === parent);
      const customOrder = [
        "Reschedule",
        "Urgent",
        "Positive",
        "Calendar inspection",
        "Introduction",
        "Wrong contact",
        "Negative",
        "Cold",
        "Other Answer",
        "Conversation",
        "No Interation",
        "Wrong number",
        "Total",
      ];

      const entries = Object.entries(x);

      entries.sort(([keyA, valueA], [keyB, valueB]) => {
        const indexA = customOrder.indexOf(valueA.label);
        const indexB = customOrder.indexOf(valueB.label);
        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });

      return entries.map(([, value]) => value);
    },

    getStatsTypeByParentQualifications(parent) {
      if (this.type == "timing") {
        let x = this.statsTypeQualifications.filter((e) => e.parent === parent);
        const entries = Object.entries(x);
        entries.sort(([keyA, valueA], [keyB, valueB]) => {
          let a = valueA.label == "Total" ? 9999 : parseInt(valueA.label);
          let b = valueB.label == "Total" ? 9999 : parseInt(valueB.label);
          return a - b;
        });
        return entries.map(([, value]) => value);
      }

      const qualificationsDetailOrder = [
        "Meeting booked",
        "Meeting rescheduled",
        "Callback requested",
        "Callback prospect busy",
        "Callback interrupted",
        "No answer",
        "Not decision maker",
        "Wrong person",
        "Call interrupted",
        "Voicemail no pitch",
        "Voicemail pitch left",
        "Soft refusal",
        "Hard refusal",
        "Opt out request",
        "Out of scope",
        "Meeting refused send email",
        "Total",
      ];

      let x = this.statsTypeQualifications.filter((e) => e.parent === parent);
      const entries = Object.entries(x);
      entries.sort(([keyA, valueA], [keyB, valueB]) => {
        const indexA = qualificationsDetailOrder.indexOf(valueA.label);
        const indexB = qualificationsDetailOrder.indexOf(valueB.label);
        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });
      return entries.map(([, value]) => value);
    },

    getRate(a, b) {
      if (b == 0) {
        return 0;
      } else {
        return (parseFloat(a) / parseFloat(b)) * 100;
      }
    },
  },
};
</script>
